import { store } from 'store/store';
import { meetDependency } from './DependencyService';
import { TypeGuardService } from './TypeGuardService';

export const mapPackages = (fields: Fields): Map<string, PackageConfig> => {
	const packages: Map<string, PackageConfig> = new Map();
	fields?.items?.forEach((field: FieldsContent) => {
		if (TypeGuardService.isPackageDetailsBlock(field.content)) {
			const coverGroups: CoverGroup[] = [];
			field.content.includedCovers?.items?.forEach((cover: CoverageGroupDetailsBlock) => {
				addRemoveCoverage(coverGroups, cover, true);
			});
			field.content.notIncludedCovers?.items?.forEach((cover: CoverageGroupDetailsBlock) => {
				addRemoveCoverage(coverGroups, cover, false);
			});
			packages.set(field.content.packageName, {
				coverages: coverGroups,
				discountText: field.content.discountText,
				isPrimaryPackage: field.content.isPrimary,
			});
		}
	});
	return packages;
};

const addRemoveCoverage = (coverGroups: CoverGroup[], cover: CoverageGroupDetailsBlock, isActive: boolean) => {
	const coverGroup = mapCoverage(cover, isActive);
	let addItem = true;
	if (coverGroup.contentDependency?.dependsOn?.uid) {
		addItem = meetDependency(coverGroup.contentDependency);
	}

	if (addItem) {
		coverGroups.push(coverGroup);
	}
};

const mapCoverage = (cover: CoverageGroupDetailsBlock, isActive: boolean): CoverGroup => {
	const coverage = cover.content;
	return {
		coverName: coverage.coverageTooltip?.linkText,
		cover_group_id: coverage.coverageGroupId.uid,
		coverDescription: {
			content: coverage.coverageTooltip?.content,
			subtitle: coverage.coverageTooltip?.subtitle,
			title: coverage.coverageTooltip?.title,
		},
		isActive,
		uniqueIdentifier: coverage.uniqueIdentifier,
		contentDependency: coverage.contentDependency,
	};
};

export const isPackageStep = (pageData: StepBlock): boolean => {
	return isPackageStepByPageId(pageData?.contentId);
};

export const isPackageStepByPageId = (pageId: number): boolean => {
	const activePages = store.getState().pages?.contentArea?.priceArea?.content?.activePages;
	if (!pageId || !activePages || activePages.length < 1) {
		return false;
	}
	let packageStepId = -1;
	activePages.forEach((page) => {
		if (packageStepId === -1) {
			page?.fields?.items?.forEach((item) => {
				if (item.content?.contentType === 'PackageGroupBlock') {
					packageStepId = page.contentId;
				}
			});
		}
	});

	return packageStepId === pageId;
};

export const isSummaryStepByPageId = (pageId: number): boolean => {
	// we need another value to determine whether we are on the summary step
	return isStepByPageId(pageId, 'Opsummering');
};

export const isReceiptStepByPageId = (pageId: number): boolean => {
	// we need another value to determine whether we are on the receipt step
	return isStepByPageId(pageId, 'Tak for dit køb!');
};

export const isStepByPageId = (pageId: number, title: string): boolean => {
	const activePages = store.getState().pages?.contentArea?.postPriceArea?.content?.activePages;
	if (!pageId || !activePages || activePages.length < 1) {
		return false;
	}
	let packageStepId = -1;
	activePages.forEach((page) => {
		if (packageStepId === -1 && page?.title === title) {
			packageStepId = page.contentId;
		}
	});

	return packageStepId === pageId;
};
